import React from 'react';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import { Item, SectionTitle, TextWrapper, Wrap, Text } from './styled';

const itemsPayload = [
    {
        image: 'https://res.cloudinary.com/grover/image/upload/v1649320401/rent_aulhla.svg',
        alt: 'Rent',
        title: 'HOMEPAGE_HOWITWORKS_SECTION_RENT_TITLE',
        description: 'HOMEPAGE_HOWITWORKS_SECTION_RENT',
    },
    {
        image: 'https://res.cloudinary.com/grover/image/upload/v1649320401/relax_cmybbv.svg',
        alt: 'Relax',
        title: 'HOMEPAGE_HOWITWORKS_SECTION_RELAX_TITLE',
        description: 'HOMEPAGE_HOWITWORKS_SECTION_RELAX',
    },
    {
        image: 'https://res.cloudinary.com/grover/image/upload/v1649320401/recirculate_sjoogz.svg',
        alt: 'Recirculate',
        title: 'HOMEPAGE_HOWITWORKS_SECTION_RECIRCULATE_TITLE',
        description: 'HOMEPAGE_HOWITWORKS_SECTION_RECIRCULATE',
    },
];

const ValuePropsSection = () => (
    <Wrap>
        {itemsPayload.map((item) => (
            <Item key={item.alt}>
                <img src={item.image} alt={item.alt} />
                <TextWrapper>
                    <SectionTitle>
                        <Translator tk={item.title} />
                    </SectionTitle>
                    <Text>
                        <Translator tk={item.description} />
                    </Text>
                </TextWrapper>
            </Item>
        ))}
    </Wrap>
);

export default ValuePropsSection;
